/** Canonical sport labels for post forms and filters across the app. */
export const SPORTS = [
  "Cricket",
  "Box Cricket",
  "Football",
  "Badminton",
  "Tennis",
  "Volleyball",
  "Basketball",
  "Kabaddi",
  "Field Hockey",
  "Pickleball",
  "Table Tennis",
  "Ultimate Frisbee",
  "Athletics / Running",
  "Other Outdoor Sports"
];

export const DEFAULT_SPORT = "Cricket";
